import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  alpha,
  Stack,
  IconButton,
  Tooltip,
  FormControl,
  Select,
  OutlinedInput,
  MenuItem,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useTheme } from "@emotion/react";
import useThemeStore from "../../hooks/store/useThemeStore";
import useApi from "../../hooks/useApi";
import { useSnack } from "../../hooks/store/useSnack";
import PhoneIcon from "../../icons/PhoneIcon";
import { useSignin } from "../../hooks/store/useSignin";
import ButtonWithLoading from "../ui/button/ButtonWithLoading";
import MobileInput from "../ui/form/MobileInput";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import TermsDialog from "../terms&condtions/TermsDialog";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { APIS } from "../../api/lists";
import OrgIcon from "../../icons/OrgIcon";
import Input from "../ui/form/Input";

const AddMobileNumberForm = ({ openNextForm }) => {
  const { darkMode } = useThemeStore();
  const { setSnack } = useSnack();
  const { apiCall, isLoading } = useApi(true);
  const { apiCall: api } = useApi();
  const { typography, palette } = useTheme();
  const {
    setMobileNumber,
    mobileNumber,
    setAccountTypeDetails,
    accountType: accountTypeS,
    orgName: orgNames,
    EIN: EINS,
  } = useSignin();
  let [openTncDialog, setOpenTncDialog] = useState(false);
  let [acceptTnc, setAcceptTnc] = useState(false);
  let [tncError, setTncError] = useState(false);
  let [accTypeError, setAccTypeError] = useState(false);
  const [accountType, setAccountType] = useState(
    accountTypeS ? accountTypeS : false
  );
  const [openMenu, setOpenMenu] = useState(false);
  const [options, setOptions] = useState([
    {
      _id: "65cddfba7c4bd61528b85466",
      label: "Non-profit",
      value: "non-profit",
      description:
        "A 501(c)(3) nonprofit is an organization recognized by the IRS for its charitable, educational, or religious mission. It's exempt from federal income tax and often eligible to receive tax-deductible donations, operating primarily for the public benefit within IRS-defined guidelines.",
      createdAt: "2024-02-15T09:56:10.972Z",
      updatedAt: "2024-02-15T09:56:10.972Z",
      __v: 0,
      order: 1,
    },
    {
      _id: "65cddfba7c4bd61528b85464",
      label: "Organization",
      value: "organization",
      description:
        "An organization refers to a structured group or entity, which can encompass businesses, associations, clubs, or any group with defined goals, activities, and members. It can operate for various purposes, including commercial, social, or charitable objectives.",
      createdAt: "2024-02-15T09:56:10.971Z",
      updatedAt: "2024-02-15T09:56:10.971Z",
      __v: 0,
      order: 2,
    },
    {
      _id: "65cddfba7c4bd61528b85465",
      label: "Individual",
      value: "individual",
      description:
        "An individual fundraiser is someone seeking financial support for personal endeavors, charitable causes, or specific projects. This could include politicians raising campaign funds, individuals crowdfunding for personal trips, or supporters seeking contributions for charitable causes, advocating for support from a network of donors or supporters.",
      createdAt: "2024-02-15T09:56:10.972Z",
      updatedAt: "2024-02-15T09:56:10.972Z",
      __v: 0,
      order: 3,
    },
  ]);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    // disableScrollLock: true,
    PaperProps: {
      style: {
        marginTop: "15px",
        borderRadius: "8px",
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        backgroundColor: darkMode ? palette.grey[550] : palette.white[1000],
        color: darkMode ? palette.white[1000] : palette.black[1000],
      },
    },
  };

  // form handling
  // validation
  const phoneRegExp =
    /^(\+\d{1,4}(\s|-)?)?\(?\d{3}\)?[-.\s]?\d{3}[-.\s]?\d{4}$/;
  const einRegExp = /^(\d{2}\d{7})$/;
  let nonProfileSchema = {
    orgName: Yup.string().required("Organization name is required"),
    EIN: Yup.string()
      .required("EIN is required")
      .matches(einRegExp, "Invalid EIN number"),
  };
  let organizationSchema = {
    orgName: Yup.string()
      .required("Organization name is required")
      .min(4, " Organization name must be at least 4 characters"),
  };
  const schema = Yup.object({
    mobileNumber: Yup.string()
      .required("Mobile number is required")
      .matches(phoneRegExp, "Invalid phone number")
      .test(
        "is-unique-mobile",
        "This mobile number is already taken",
        async function (value) {
          try {
            let result = await api({
              url: `v3/users/check/mobile/${value}`,
              method: "get",
            });
            if (result.data.success) return true;
            else return false;
          } catch (error) {
            return false; // Return false in case of an error
          }
        }
      ),
    ...(accountType.value === "non-profit" ? nonProfileSchema : {}),
    ...(accountType.value === "organization" ? organizationSchema : {}),
  });
  const { register, handleSubmit, formState } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      mobileNumber: mobileNumber,
      orgName: orgNames,
      EIN: EINS,
    },
  });

  const AddNumber = async (values) => {
    try {
      if (!accountType) {
        return setAccTypeError(true);
      }

      //check user accepts terms and conditions or not
      if (!acceptTnc) {
        return setTncError(true);
      }

      let mobileNumber = values.mobileNumber;
      let orgName = values.orgName;
      let EIN = values.EIN;
      setMobileNumber(mobileNumber, 1);
      setAccountTypeDetails(accountType, orgName, EIN);

      await apiCall({
        url: "v2/accounts/get-otp",
        method: "post",
        data: {
          code: "1",
          mobile: values.mobileNumber,
          OTP_description: "registration",
        },
      });
      console.log(mobileNumber);
      setSnack(
        "Please verify your phone number to login. We've sent a verification code to your mobile number.",
        "success"
      );
      openNextForm("Varify");
    } catch (error) {
      if (error.code === 401) {
        // request for otp varification
      } else {
        setSnack(error.response.data.message, "error");
      }
    }
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setAccountType(value);
    setAccTypeError(false);
  };

  async function getAccountType() {
    try {
      let response = await apiCall({
        url: APIS.ACCOUNTTYPE.LIST,
        method: "get",
      });
      setOptions(response.data.data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    getAccountType();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Box
        component={"form"}
        sx={{
          minWidth: { md: "571px" },
          paddingInline: { xs: "20px", md: "30px", lg: "60px" },
          paddingBlock: { xs: "20px", lg: "50px" },
          backgroundColor: darkMode ? "bgDark.third" : "white.1000",
          borderRadius: { xs: "10px", lg: "18px" },
          marginTop: { xs: 0, lg: "50px" },
          boxShadow: "0px 0px 100px rgba(0, 0, 0, 0.06)",
        }}
        onSubmit={handleSubmit(AddNumber)}
      >
        <Box
          sx={{
            maxWidth: "431px",
            margin: "0 auto",
            display: { xs: "flex", md: "block" },
            flexDirection: "column",
            height: { xs: "90vh", md: "unset" },
          }}
        >
          {/* form headings */}
          <Typography
            sx={{
              mb: "5px",
              color: darkMode ? "white.1000" : "black.1000",
              fontFamily: typography.manrope,
              fontSize: { xs: "26px", lg: "36px" },
              fontWeight: { xs: 800, lg: 700 },
              lineHeight: { xs: "40px", lg: "122%" },
              letterSpacing: { xs: "-0.52px", md: "-0.72px" },
            }}
          >
            Verify Your Mobile Number
          </Typography>

          <Box sx={{ paddingTop: { lg: "10px" }, flex: "1" }}>
            <MobileInput
              name={"mobileNumber"}
              inputLabel={"Mobile Number"}
              type="number"
              register={register}
              errors={formState.errors}
              placeholder="Enter Mobile Number"
              icon={
                <PhoneIcon
                  color={
                    darkMode ? palette.white["1000"] : palette.black["450"]
                  }
                />
              }
            />
            <FormControl sx={{ width: "100%", mt: "30px" }}>
              <InputLabel
                sx={{
                  "&.MuiFormLabel-root": {
                    backgroundColor: darkMode ? "bgDark.third" : "white.1000",
                    color: darkMode ? "white.1000" : "primary.main",
                    fontSize: "16px",
                    fontWeight: 500,
                    fontStyle: "normal",
                    lineHeight: "normal",
                    textTransform: "capitalize",
                  },
                }}
                id="demo-multiple-chip-label"
              >
                account Type
              </InputLabel>
              <Select
                open={openMenu}
                onClose={() => setOpenMenu(false)}
                onOpen={() => setOpenMenu(true)}
                IconComponent={(props) => (
                  <KeyboardArrowDownIcon
                    sx={{
                      "&.MuiSelect-icon": {
                        color: darkMode ? "white.1000" : "black,1000",
                      },
                    }}
                    {...props}
                  />
                )}
                sx={{
                  "&.MuiOutlinedInput-root": {
                    padding: "0",
                    backgroundColor: darkMode ? "transparent" : "white.1000",
                    color: darkMode ? "white.1000" : "black.1000",
                    border: "1px solid",
                    borderColor: darkMode ? "bgDark.third" : "neutral.150",
                    borderRadius: "8px",
                  },
                  "& .MuiOutlinedInput-input": {
                    border: "1px solid",
                    borderColor: darkMode ? "neutral.650" : "white.1000",
                    borderRadius: "10px",
                    padding: "15.5px 20px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiPaper-root": {
                    marginTop: "20px !important",
                  },
                }}
                displayEmpty
                value={accountType}
                onChange={handleChange}
                input={<OutlinedInput />}
                renderValue={(selected) => {
                  if (!accountType) {
                    return "Select Account Type";
                  }

                  return selected.value;
                }}
                MenuProps={MenuProps}
                // inputProps={{ "aria-label": "Without label" }}
              >
                {options.map(({ description, label, _id, value }) => (
                  <MenuItem
                    key={_id}
                    value={{ value, _id }}
                    selected
                    sx={{
                      "&:focus": {
                        color: "black !important",
                        backgroundColor: "transparent",
                        "& .item-option": {
                          color: darkMode
                            ? palette.white[1000]
                            : palette.black[1000],
                        },
                        "& .option-tooltip": {
                          color: darkMode ? "white.1000" : "black.1000",
                        },
                      },
                      "& .item-option": {
                        color: darkMode
                          ? palette.primary.disabledLight
                          : palette.primary.disabledLight,
                      },
                      "& .option-tooltip": {
                        color: darkMode
                          ? palette.primary.disabledLight
                          : palette.primary.disabledLight,
                      },
                      paddingInline: 0,
                      marginInline: "20px",
                      borderBottom: "1px solid",
                      borderColor: darkMode ? "neutral.650" : "grey.100",
                      borderRadius: "0px !important",
                      "&:last-child": {
                        borderBottom: "none",
                      },
                    }}
                  >
                    <Stack
                      sx={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBlock: "7px",
                      }}
                    >
                      <Typography className="item-option">{label}</Typography>
                      <Tooltip
                        title={description}
                        placement="bottom-end"
                        arrow
                        componentsProps={{
                          tooltip: {
                            sx: {
                              fontSize: { xs: "12px", md: "14px" },
                              color: darkMode ? "white.1000" : "black.1000",
                              backgroundColor: darkMode
                                ? "black.250"
                                : "grey.1100",
                            },
                          },
                        }}
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-arrow": {
                              "&::before": {
                                backgroundColor: darkMode
                                  ? "black.250"
                                  : "grey.1100",
                              },
                            },
                          },
                        }}
                      >
                        <IconButton
                          className="option-tooltip"
                          sx={{
                            padding: 0,
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <ErrorRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    </Stack>
                  </MenuItem>
                ))}
              </Select>
              {accTypeError && (
                <FormHelperText
                  sx={{
                    "&.MuiFormHelperText-root": {
                      marginLeft: 0,
                    },
                  }}
                >
                  <>
                    <Stack
                      component={"span"}
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        color: "error.main",
                      }}
                    >
                      <ErrorOutlineRoundedIcon
                        sx={{ fontSize: "16px", mr: "10px" }}
                      />
                      <Box component={"span"}>Please select account type</Box>
                    </Stack>
                  </>
                </FormHelperText>
              )}
            </FormControl>

            {(accountType.value === "organization" ||
              accountType.value === "non-profit") && (
              <Input
                name={"orgName"}
                inputLabel={"Organization"}
                type="text"
                register={register}
                errors={formState.errors}
                placeholder="Enter a Organization"
                icon={
                  <OrgIcon
                    color={
                      darkMode ? palette.white["1000"] : palette.black["450"]
                    }
                  />
                }
              />
            )}

            {accountType.value === "non-profit" && (
              <Input
                name={"EIN"}
                inputLabel={"EIN"}
                type="text"
                register={register}
                errors={formState.errors}
                placeholder="Enter EIN Number"
                icon={
                  <OrgIcon
                    color={
                      darkMode ? palette.white["1000"] : palette.black["450"]
                    }
                  />
                }
              />
            )}

            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                gap: "0px",
                mt: "15px",
              }}
            >
              <FormControlLabel
                name="termAndCondition"
                sx={{ "&.MuiFormControlLabel-root": { mr: 0 } }}
                control={
                  <Checkbox
                    onClick={() => {
                      setAcceptTnc(!acceptTnc);
                      setTncError(acceptTnc);
                    }}
                    // color={"red"}
                    checked={acceptTnc}
                    sx={{ color: darkMode ? "neutral.650" : "black.100" }}
                  />
                }
              />
              <Typography
                sx={{
                  fontFamily: typography.manrope,
                  color: darkMode ? "grey.900" : "neutral.350",
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "146%",
                }}
              >
                I accept{" "}
                <Typography
                  component={"span"}
                  // to="/terms-and-condition"
                  // target="_black"
                  onClick={() => setOpenTncDialog(true)}
                  sx={{
                    cursor: "pointer",
                    textDecoration: "none",
                    color: darkMode ? "white.1000" : "primary.main",
                    fontFamily: typography.manrope,
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "146%",
                  }}
                >
                  Terms & Conditions
                </Typography>
              </Typography>
            </Stack>
            {tncError && (
              <Stack
                component={"span"}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  fontSize: "12px",
                  color: "error.main",
                }}
              >
                <ErrorOutlineRoundedIcon
                  sx={{ fontSize: "16px", mr: "10px" }}
                />
                <Box component={"span"}>Please accept terms and conditions</Box>
              </Stack>
            )}
            <ButtonWithLoading
              color="primary"
              disabled={formState.isSubmitting || isLoading}
              isLoading={isLoading}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
              sx={{
                fontFamily: typography.manrope,
                fontSize: "16px",
                fontWeight: 500,
                lineHeight: "152%",
                padding: "14px 12px",
                marginTop: { xs: "20px", lg: "40px" },
                borderRadius: "10px",
                textTransform: "capitalize",
                "&.Mui-disabled": {
                  color: darkMode
                    ? alpha(palette.white["1000"], 0.7)
                    : "white.1000",
                  backgroundColor: darkMode
                    ? "primary.disabledDark"
                    : "primary.disabledLight",
                },
              }}
            >
              Sign in
            </ButtonWithLoading>
          </Box>
        </Box>

        <TermsDialog
          openTncDialog={openTncDialog}
          setOpenTncDialog={setOpenTncDialog}
          setAcceptTnc={() => {
            setAcceptTnc(true);
            setTncError(false);
          }}
        />
      </Box>
    </>
  );
};

export default AddMobileNumberForm;
